import { hasQueryStringParameter } from 'owa-querystring';

/**
 * If the user is gulping or branching accordingly from the querystring
 */
export default function isGulpOrBranching() {
    return hasQueryStringParameter('gulp') || hasQueryStringParameter('branch');
}
